<template>
  <div>
    <section class="section is-title-bar">
      <div class="level is-mobile">
        <div class="level-left">
          <div class="level-item">
            <p class="title is-5">Create Activity</p>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <router-link
              :to="{ name: 'photogallaryList' }"
              class="button is-info is-small btnicon"
              title="Back To List"
            >
              Back To List
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <section class="container section is-main-section">
      <form @submit.prevent="save">
        <div>
          <div class="columns form-row">
            <div class="column">
              <div class="field">
                <label class="label"
                  >Select Academic Year
                  <span class="has-text-danger">*</span></label
                >
                <div class="control">
                  <div class="select is-fullwidth">
                    <select v-model="academicYearID" required>
                      <option value="">-select</option>
                      <option
                        v-for="year in academicYears"
                        :key="year.id"
                        :value="year.id"
                      >
                        {{ year.academicYear }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">
                  User type<span class="has-text-danger">*</span>
                </label>
                <div class="control select is-fullwidth">
                  <select
                    v-on:change="clearData()"
                    name="userSelect"
                    required
                    v-model="UserType"
                  >
                    <option disabled value>--Select--</option>
                    <option value="ALL">ALL</option>
                    <option value="STUDENT_WISE">STUDENT</option>
                  </select>
                </div>
              </div>
            </div>
            <div
              v-if="this.UserType !== 'STUDENT_WISE'"
              class="column border-down is-4"
            >
              <div class="field">
                <label class="label">
                  Select Franchisee<span class="requir has-text-danger"
                    >*</span
                  ></label
                >
                <!-- <div class="level-left">
                  <b-checkbox v-model="flag" @input="allFranchisee"></b-checkbox>All Franchisee
                </div> -->
                <div class="control select is-fullwidth">
                  <multiselect
                    class="overflowmultiselect2"
                    label="companyName"
                    track-by="companyName"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    :preselect-first="false"
                    :multiple="true"
                    :options="franchiseeArr"
                    v-model="selectedFranchisee"
                  >
                  </multiselect>
                </div>
              </div>
            </div>
            <div v-if="this.UserType === 'STUDENT_WISE'" class="column">
              <div class="field">
                <label class="label"
                  >Select franchisee
                  <span class="has-text-danger">*</span></label
                >
                <div class="control">
                  <div class="select is-fullwidth">
                    <select
                      v-on:change="clearAll()"
                      name="selectFranchisee"
                      required
                      v-model="franchiseeID"
                    >
                      <option disabled value>--Select--</option>
                      <option
                        :value="franchisee.id"
                        v-for="franchisee in franchiseeArr"
                        :key="franchisee.id"
                      >
                        {{ franchisee.companyName }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div v-if="this.UserType !== 'STUDENT_WISE'" class="columns row">
              <div class="column is-3">
                <div class="field">
                  <label class="label"
                    >class / section Wise<span class="has-text-danger"
                      >*</span
                    ></label
                  >
                  <div class="control p-t-7">
                    <b-radio
                      @input="clearclassSection()"
                      required
                      name="classSection"
                      v-model="classSection"
                      native-value="class"
                      class="m-r-7"
                    >
                      class
                    </b-radio>
                    <b-radio
                      name="classSection"
                      v-model="classSection"
                      native-value="section"
                    >
                      section
                    </b-radio>
                  </div>
                </div>
              </div>
              <div
                v-if="this.classSection === 'class'"
                class="column border-down is-5"
              >
                <div class="field">
                  <label class="label">
                    Select classes
                    <span class="requir has-text-danger">*</span>
                  </label>
                  <div class="control select is-fullwidth">
                    <multiselect
                      class="overflowmultiselect2"
                      label="name"
                      track-by="id"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      :preselect-first="false"
                      :multiple="true"
                      :options="classes"
                      v-model="classSelects"
                    >
                    </multiselect>
                  </div>
                </div>
              </div>
              <div
                v-if="this.classSection === 'section'"
                class="column border-down is-5"
              >
                <div class="field">
                  <label class="label">
                    Select section
                    <span class="requir has-text-danger">*</span>
                  </label>
                  <div class="control select is-fullwidth">
                    <multiselect
                      class="overflowmultiselect2"
                      label="name"
                      track-by="id"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      :preselect-first="false"
                      :multiple="true"
                      :options="tempArray"
                      v-model="sectionSelects"
                    >
                    </multiselect>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="this.UserType === 'STUDENT_WISE'">
            <div class="columns form-row">
              <div class="column">
                <div class="field">
                  <label class="label">
                    Class<span class="has-text-danger">*</span>
                  </label>
                  <div class="control select is-fullwidth">
                    <select
                      name="classSelect"
                      required
                      v-model="selectedClassID"
                      v-on:change="changeSections()"
                    >
                      <option value>Select</option>
                      <option
                        :value="class1.id"
                        v-for="class1 in classes"
                        :key="class1.id"
                        :v-bind="class1.id"
                      >
                        {{ class1.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <label class="label">
                    Select Section<span class="has-text-danger">*</span>
                  </label>
                  <div class="control select is-fullwidth">
                    <select
                      v-on:change="students()"
                      required
                      name="sectionSelect"
                      v-model="selectedSectionID"
                    >
                      <option value>Select</option>
                      <option
                        :value="section.id"
                        v-for="section in classWiseSections"
                        :key="section.id"
                        :v-bind="section.id"
                      >
                        {{ section.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="column border-down is-5">
                <div class="field">
                  <label class="label">
                    Select Student
                    <span class="requir has-text-danger">*</span>
                  </label>
                  <div class="control select is-fullwidth">
                    <multiselect
                      class="overflowmultiselect2"
                      label="name"
                      track-by="id"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      :preselect-first="false"
                      :multiple="true"
                      :options="studentArray"
                      v-model="selectedStudent"
                    >
                    </multiselect>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="columns row"><br /><br /><br /></div>
          <div class="columns row">
            <div class="column is-4">
              <label class="label"
                >From <span class="has-text-danger">*</span></label
              >
              <div class="control">
                <input class="input" type="date" v-model="fromDate" required />
              </div>
            </div>

            <div class="column is-4">
              <label class="label"
                >To <span class="has-text-danger">*</span></label
              >
              <div class="control">
                <input
                  class="input"
                  :min="this.fromDate"
                  type="date"
                  v-model="toDate"
                  required
                />
              </div>
            </div>
            <div class="column is-4">
              <div class="field">
                <label class="label">
                  Title <span class="has-text-danger">*</span></label
                >
                <div class="control">
                  <input
                    class="input"
                    v-model.trim="title"
                    required
                    type="text"
                  />
                </div>
              </div>
            </div>
            <div class="column is-10" style="width: 100%">
              <div class="field">
                <label class="label">
                  Description
                  <span class="requir has-text-danger">*</span></label
                >
                <!-- <ckeditor required v-model="discription" ref="ckeditorRef"></ckeditor> -->
                <!-- <textarea
                  class="input"
                  rows="3"
                  required
                  clearable
                  v-model="discription"
                  ref="ckeditorRef"
                ></textarea> -->
                <quill-editor
                  v-model="discription"
                  theme="snow"
                  ref="myQuillEditor"
                >
                </quill-editor>
              </div>
            </div>
            <div class="form-row">
              <div class="column is-10">
                <div class="field">
                  <label class="label"
                    >Image / Video (please select image or video for
                    upload)<span class="requir has-text-danger">*</span></label
                  >
                  <div class="control p-t-7">
                    <b-radio
                      @input="changed()"
                      required
                      name="imagevideo"
                      v-model="imagevideo"
                      native-value="image"
                    >
                      Image
                    </b-radio>
                    <b-radio
                      name="imagevideo"
                      v-model="imagevideo"
                      native-value="video"
                    >
                      Video
                    </b-radio>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="this.imagevideo === 'image'" class="column is-6">
              <div class="field">
                <label class="label">upload / Insert Url </label>
                <div class="control p-t-7">
                  <b-radio
                    required
                    @input="change()"
                    name="uploadcopy"
                    v-model="uploadcopy"
                    native-value="upload"
                  >
                    upload
                  </b-radio>
                  <b-radio
                    name="uploadcopy"
                    v-model="uploadcopy"
                    native-value="copy"
                  >
                    Insert Url
                  </b-radio>
                </div>
              </div>
              <div v-if="this.uploadcopy === 'copy'" class="column is-5">
                <div class="field">
                  <label class="label"> Image Url </label>
                  <div class="control">
                    <input
                      class="input"
                      v-model.trim="imgUrl"
                      required
                      type="url"
                    />
                  </div>
                </div>
              </div>
              <div v-if="this.uploadcopy === 'upload'" class="column is-5">
                <div class="field">
                  <label class="label">
                    select file
                    <span class="requir has-text-danger">*</span>
                  </label>
                  <b-field
                    :class="`file ${
                      this.dropFile.length > 9 ? ' ' : 'is-primary'
                    }`"
                  >
                    <b-upload
                      v-model="dropFile"
                      :disabled="this.dropFile.length > 9"
                      :required="this.dropFile.length < 1"
                      @input="onFilechange()"
                      multiple
                      class="file-label"
                    >
                      <span class="file-cta">
                        <b-icon class="file-icon" icon="upload"></b-icon>
                        <span class="file-label">Click to upload</span>
                      </span>
                    </b-upload>
                  </b-field>
                  <span class="has-text-danger">please select only image</span>

                  <span v-if="dropFile.length > 0">
                    <div class="tags" v-for="(file, i) in dropFile" :key="i">
                      <span class="tag is-primary">
                        {{ file.type }}
                      </span>
                      <button
                        class="delete is-small"
                        type="button"
                        @click="deleteDropFile(i)"
                      ></button>
                    </div>
                  </span>
                </div>
              </div>
            </div>
            <div v-if="this.imagevideo === 'video'" class="column is-3">
              <div class="field">
                <label class="label"> Video Url </label>
                <div class="control">
                  <input
                    :disabled="this.dropFile.length > 9"
                    class="input"
                    v-model.trim="vdoUrl"
                    required
                    type="url"
                  />
                </div>
              </div>
            </div>
          </div>
          <button
            class="button is-success"
            :disabled="hasClicked"
            type="submit"
            style="margin-top: 38px"
          >
            Create
          </button>
        </div>
        <div></div>
      </form>
    </section>
  </div>
</template>

<script>
import constants from '@/utils/constants'

import Utils from '@/utils'
import Multiselect from 'vue-multiselect'
// import Vue from 'vue'
// import CKEditor from 'ckeditor4-vue'
// Vue.use(CKEditor)
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
export default {
  name: 'addPhotogallary',
  components: {
    quillEditor,
    Multiselect
  },
  data () {
    return {
      total: 0,
      dropFile: [],
      franchiseeID: '',
      fromDate: '',
      toDate: '',
      franchiseeArr: [],
      academicYearID: '',
      imgUrl: '',
      classSelects: '',
      sectionSelects: '',
      selectedStudent: [],
      studentData: [],
      classSection: '',
      discription: '',
      UserType: '',
      selectedFranchisee: [],
      uploadcopy: '',
      vdoUrl: '',
      academicYears: [],
      sendStudent: [],
      sendFranchisee: [],
      selectedClassID: '',
      selectedSectionID: '',
      classID: '',
      imagevideo: '',
      title: '',
      classWiseSections: [],
      classes: [],
      sections: [],
      tempArray: [],
      studentArray: [],
      sendclassID: [],
      sendsectionID: [],
      hasClicked: false,
      loader: true,
      selectedfranchiseeID: [],
      isWrite: false
    }
  },

  async created () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    await this.getClassList()
    await this.getFranchiseeList()
    await this.getYear()
  },
  beforeRouteLeave (to, from, next) {
    // Ckeditor maximize fix and Alert on unsaved changes
    // const that = this.$refs.ckeditorRef
    // const maximizedState = that.instance.getCommand('maximize').state
    // if (maximizedState === 1) { that.instance.execCommand('maximize') }
    // if (this.hasDataChanged() && !this.hasClicked) {
    //   return this.$buefy.dialog.confirm({
    //     title: 'Leave Page',
    //     message: 'Do you really want to leave? you have unsaved changes!',
    //     type: 'is-danger',
    //     cancelText: 'No',
    //     confirmText: 'Yes',
    //     onConfirm: () => { next() },
    //     onCancel: () => { next(false) }
    //   })
    // } else
    next()
  },
  beforeMount () {
    window.addEventListener('beforeunload', this.preventNav)
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.preventNav)
  },
  methods: {
    preventNav (event) {
      if (!this.hasDataChanged()) return
      event.preventDefault()
      event.returnValue = ''
    },
    hasDataChanged () {
      const boolAlert =
        this.discription ||
        this.dropFile.length > 0 ||
        this.title ||
        this.fromDate ||
        this.toDate ||
        this.imgUrl ||
        this.vdoUrl ||
        this.UserType ||
        this.selectedFranchisee.length > 0
      return boolAlert
    },
    getYear: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(
          `${constants.API_URL}/api/franchiseeAcademicYears?isCurrentAcademicYear=false`
        )
        this.academicYears = data.rows
        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = this.academicYears.find((y) => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.academicYearID = academicYear ? academicYear.id : ''

        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    deleteDropFile (i) {
      this.dropFile.splice(i, 1)
    },
    getFranchiseeList: async function () {
      try {
        const response = await http.get(
          `${constants.API_URL}/api/franchisee/active`
        )
        let data = response.data
        this.franchiseeArr = data.rows
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching franchisee', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getClassList: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(
          `${constants.API_URL}/api/student/class-section?isRequired=false`
        )
        if (data) {
          this.classes = data.map((obj) => {
            return {
              id: obj.id,
              name: obj.name
            }
          })
          this.sections = data.map((obj) => {
            return {
              id: obj.id,
              name: obj.name,
              sections: obj.studentSections
            }
          })
        }
        data.map((a) => {
          a.studentSections.map((b) => {
            this.tempArray.push({
              id: b.id,
              name: `${a.name}-${b.name}`
            })
          })
        })
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    changeSections: async function () {
      this.selectedStudent = []
      this.studentArray = []
      try {
        this.loadingComponent = this.$buefy.loading.open()
        let sectionarray = this.sections.find(
          (obj) => obj.id === this.selectedClassID
        )
        if (sectionarray) {
          this.classWiseSections = sectionarray.sections
        } else {
          this.classWiseSections = 0
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      } finally {
        this.loadingComponent.close()
      }
    },
    students: async function () {
      if (this.UserType === 'STUDENT_WISE' && this.franchiseeID.length === 0) {
        return this.$buefy.toast.open({
          message: 'Please select Franchisee',
          type: 'is-danger',
          duration: 4000
        })
      }
      this.selectedStudent = []
      this.studentArray = []
      let studentData = {
        isActive: 'true',
        franchiseeID: this.franchiseeID,
        classID: this.selectedClassID,
        sectionID: this.selectedSectionID,
        academicYearID: this.academicYearID
      }
      try {
        this.loadingComponent = this.$buefy.loading.open()
        let { data } = await http.post(
          `${constants.API_URL}/api/student`,
          studentData
        )
        if (data.length === 0) {
          this.$buefy.snackbar.open({
            duration: 7000,
            message: `No student Found with selected class and section`,
            position: 'is-top-right',
            type: 'is-danger'
          })
        } else {
          this.studentArray = data.map((a) => {
            return {
              id: a.id,
              name: a.studentEnrollment.studentName
            }
          })
        }
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('Error While Saving Data', errorMessage)
      }
    },
    save: async function () {
      let discriptionTest = this.discription
      discriptionTest = discriptionTest.replace(/(<([^>]+)>)/gi, '')
      discriptionTest = discriptionTest.replace(/&nbsp;/g, '')
      discriptionTest = discriptionTest.trim()
      if (
        discriptionTest === '' ||
        !discriptionTest ||
        discriptionTest === null
      ) {
        return this.$buefy.toast.open({
          message: 'Please fill Description',
          type: 'is-danger',
          duration: 4000
        })
      }
      if (
        this.UserType !== 'STUDENT_WISE' &&
        this.selectedFranchisee.length === 0
      ) {
        return this.$buefy.toast.open({
          message: 'Please select Franchisee',
          type: 'is-danger',
          duration: 4000
        })
      }
      if (this.classSection === 'class' && this.classSelects.length === 0) {
        return this.$buefy.toast.open({
          message: 'Please select class',
          type: 'is-danger',
          duration: 4000
        })
      }
      if (this.classSection === 'section' && this.sectionSelects.length === 0) {
        return this.$buefy.toast.open({
          message: 'Please select Section',
          type: 'is-danger',
          duration: 4000
        })
      }
      if (
        this.UserType === 'STUDENT_WISE' &&
        this.selectedStudent.length === 0
      ) {
        return this.$buefy.toast.open({
          message: 'Please select Student',
          type: 'is-danger',
          duration: 4000
        })
      }
      if (this.imagevideo === 'image' && this.uploadcopy === 'upload') {
        if (this.dropFile.length > 10) {
          return this.$buefy.toast.open({
            message: 'You are only allowed to upload a maximum of 10 files',
            type: 'is-danger',
            duration: 4000
          })
        }
      }
      if (this.classSelects.length > 0) {
        this.sendclassID = this.classSelects.map((obj) => obj.id)
      }
      if (this.sectionSelects.length > 0) {
        this.sendsectionID = this.sectionSelects.map((obj) => obj.id)
      }
      if (this.selectedStudent.length > 0) {
        this.sendStudent = this.selectedStudent.map((obj) => obj.id)
      }
      if (this.selectedFranchisee.length > 0) {
        this.sendFranchisee = this.selectedFranchisee.map((obj) => obj.id)
      }
      this.selectedfranchiseeID = [this.franchiseeID]
      this.studentData = [this.selectedStudent]
      let formData = new FormData()
      formData.append('academicYearID', this.academicYearID)
      formData.append('userType', this.UserType)
      formData.append('title', this.title)
      formData.append('startDate', this.fromDate)
      formData.append('endDate', this.toDate)
      formData.append('descriptions', this.discription)
      if (this.selectedStudent.length !== 0) {
        formData.append('studentID', JSON.stringify(this.sendStudent))
      }
      if (this.selectedFranchisee.length !== 0) {
        formData.append('franchiseeID', JSON.stringify(this.sendFranchisee))
      }
      if (this.franchiseeID.length !== 0) {
        formData.append(
          'franchiseeID',
          JSON.stringify(this.selectedfranchiseeID)
        )
      }
      if (this.classSection === 'class') {
        formData.append('classID', JSON.stringify(this.sendclassID))
      }
      if (this.classSection === 'section') {
        formData.append('sectionID', JSON.stringify(this.sendsectionID))
      }

      if (this.imagevideo === 'image' && this.uploadcopy !== 'upload') {
        formData.append('type', 'IMAGE')
        formData.append('link', this.imgUrl)
        formData.append('isLink', 'true')
      } else if (this.imagevideo === 'video') {
        formData.append('type', 'VIDEO')
        formData.append('link', this.vdoUrl)
        formData.append('isLink', 'true')
      }
      if (this.imagevideo === 'image' && this.uploadcopy === 'upload') {
        for (let i = 0; i < this.dropFile.length; i++) {
          formData.append('file', this.dropFile[i])
        }
      }
      // for (var pair of formData.entries()) {
      //   console.log(pair)
      // }
      this.hasClicked = true
      try {
        this.loadingComponent = this.$buefy.loading.open()
        await http.post(
          `${constants.API_URL}/api/communication/photo-gallery`,
          formData
        )
        this.loader = false
        this.resetInputs()
        this.loadingComponent.close()
        this.$router.push({
          name: 'photogallaryList'
        })
        return this.$buefy.dialog.alert({
          type: 'is-success',
          message: 'Saved successfully',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('Error While Details', errorMessage)
        this.lock = false
        this.hasClicked = false
        this.loader = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    clearAll: async function () {
      this.selectedClassID = ''
      this.selectedSectionID = ''
      this.selectedStudent = []
      this.studentArray = []
    },
    resetInputs () {
      this.userType = ''
      this.academicYearID = ''
      this.franchiseeID = ''
      this.typeID = ''
      this.title = ''
      this.descriptions = ''
      this.selectedfranchiseeID = []
    },
    clearData () {
      this.classSection = ''
      this.selectedFranchisee = []
      this.franchiseeID = ''
      this.classSelects = ''
      this.sectionSelects = ''
      this.studentArray = []
      this.selectedStudent = []
      this.selectedClassID = ''
      this.selectedSectionID = ''
    },
    onFilechange () {
      let size = this.dropFile.some((a) => {
        return a.size > 5000000
      })
      if (size) {
        this.dropFile.pop()
        return this.$dialog.error({
          text: `file size is too big`,
          title: 'File Upload Error'
        })
      }
      let r = this.dropFile.some((a) => {
        return (
          a.type !== 'image/jpeg' &&
          a.type !== 'image/jpg' &&
          a.type !== 'image/png'
        )
      })
      if (r === true) {
        this.dropFile.pop()
        return this.$buefy.dialog.alert({
          message: 'please select jpeg , jpg , png format only',
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    changed () {
      this.dropFile = []
      this.uploadcopy = ''
      this.imgUrl = ''
      this.vdoUrl = ''
    },
    change () {
      this.dropFile = []
      this.imgUrl = ''
    },
    clearclassSection () {
      this.classSelects = ''
      this.sectionSelects = ''
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
textarea {
  background-color: #ffffff;
  border-color: #dbdbdb;
  border-radius: 4px;
  color: #363636;
  height: 9.5rem;
}
</style>
